export const DATA = [
  { date: "02/11/2023", salary: "706.605" },
  { date: "02/11/2023", salary: "706.605" },
  { date: "02/11/2023", salary: "706.605" },
  { date: "02/11/2023", salary: "706.605" },
];

export const BASE_URL = "https://tarangtech.in/api/v1/";
